import { BASE_API_URL } from '@/lib/constants';
import { createMutation } from '@/lib/utils';
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { MutationRequest, MutationResponse } from '../booking.types';

const QueryKeys = {
  create: ['book-appointment-hold'] as const,
};

const URL = `${BASE_API_URL}/book-appointment-hold`;
export const useBookAppointmentHoldMutation = (
  options?: UseMutationOptions<MutationResponse, Error, MutationRequest>
): UseMutationResult<MutationResponse, Error, MutationRequest> => {
  return useMutation({
    mutationKey: QueryKeys.create,
    mutationFn: (data: MutationRequest) => createMutation(URL)(data),
    ...options,
  });
};
